export const WORKSHOP_REGISTRATION_STATUS_LABELS: Record<string, string> = {
  pending: "ລໍຖ້າ",
  contacted: "ຕິດຕໍ່ແລ້ວ",
  confirmed: "ຢືນຢັນ",
  rejected: "ປະຕິເສດ",
  duplicate: "ຊ້ຳ",
};

export const WORKSHOP_REGISTRATION_STATUS_VARIANTS: Record<
  string,
  "default" | "secondary" | "destructive" | "outline"
> = {
  pending: "secondary",
  contacted: "outline",
  confirmed: "default",
  rejected: "destructive",
  duplicate: "destructive",
};
